import { put, apply, select, call, takeEvery, all } from 'redux-saga/effects'
import { createAction, createReducer } from 'redux-act'
import { get } from 'lodash'
import stream from 'getstream'

import { selector as configSelector } from '~/config'

import { Entity, handleError } from '~/utils/entity-utils'

// ACTIONS
export const actions = {
  fetchList: {
    request: createAction('fetch shop feed item list', (shopFeed, params) => ({shopFeed, params})),
    failure: createAction('shop feed item list fetch error', (message, response) => ({message, response})),
    success: createAction('shop feed item list fetch success', (entityList, response) => ({entityList, response})),
  }
};

// WORKERS
export const workers = {
  * fetchEntityList(action, throwError = false) {
    try {
      const {shopFeed, params={limit: 5}} = get(action, 'payload', {});

      const client = stream.connect(shopFeed.api_key);

      const feed = client.feed('shop', shopFeed.id, shopFeed.token);

      const response = yield apply(feed, feed.get, [params]);

      yield put(actions.fetchList.success(response.results, response));

      return response.results;
    } catch (e) {
      yield call(handleError, e, actions.fetchList);
      if(throwError) {
        throw e;
      }else {
        return e;
      }
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    takeEvery(actions.fetchList.request().type, workers.fetchEntityList)
  ]);
}

const key = 'id';
export const reducer = createReducer({
  [actions.fetchList.success]: (state, payload) => {
    if(payload[`entityList`]) {
      let newState = Object.assign({}, state);
      payload[`entityList`].forEach(object => newState[object[key]] = object);
      return newState
    }
    return state;
  },
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}